import { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { copierTexte } from './copier';

/**
 * « Copier le message » : le bouton dit « Copié » deux secondes (et le lecteur d'écran l'annonce), ou explique quand le navigateur
 * refuse. `etiquette` donne un nom complet au bouton (« Copier l'e-mail pour Claire D. ») quand plusieurs boutons se ressemblent.
 */
export function BoutonCopier({ texte, libelle = 'Copier le message', etiquette, accent = false, petit = true }: {
  texte: string; libelle?: string; etiquette?: string; accent?: boolean; petit?: boolean;
}) {
  const [etat, setEtat] = useState<'repos' | 'copie' | 'refuse'>('repos');
  const minuteur = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (minuteur.current) clearTimeout(minuteur.current); }, []);

  async function copier() {
    const ok = await copierTexte(texte);
    setEtat(ok ? 'copie' : 'refuse');
    if (minuteur.current) clearTimeout(minuteur.current);
    minuteur.current = setTimeout(() => setEtat('repos'), ok ? 2000 : 6000);
  }

  return (
    <>
      <button type="button" className={`btn${petit ? ' btn-sm' : ''}${accent ? ' btn-accent' : ''}`} onClick={copier} aria-label={etiquette}>
        {etat === 'copie' ? <Check className="icon-sm" /> : <Copy className="icon-sm" />} {etat === 'copie' ? 'Copié' : libelle}
      </button>
      <span className="sr-only" role="status">{etat === 'copie' ? 'Copié dans le presse-papiers' : ''}</span>
      {etat === 'refuse' && <span className="text-xs text-err" role="alert">Copie impossible : sélectionnez le texte et copiez-le à la main.</span>}
    </>
  );
}
